(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDeleteController',MaterialFileIbqDeleteController);

    MaterialFileIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'MaterialFile'];

    function MaterialFileIbqDeleteController($uibModalInstance, entity, MaterialFile) {
        var vm = this;

        vm.materialFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MaterialFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
